import type {FC} from "react";

interface DeleteDriverModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    driverName: string;
    deliveryCount: number;
    loading: boolean;
}

const DeleteDriverModal: FC<DeleteDriverModalProps> = ({isOpen, onClose, onConfirm, driverName, deliveryCount, loading}) => {
    if (!isOpen) return null;

    const isBlocked = deliveryCount > 0;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-stone-900/40 backdrop-blur-sm" onClick={onClose} />
            <div className="relative w-full max-w-md rounded-2xl bg-white shadow-xl ring-1 ring-stone-200 p-6">
                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-red-50">
                    <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>

                <h3 className="text-lg font-semibold text-center text-gray-900">
                    {isBlocked ? 'Deletion Blocked' : 'Confirm Deletion'}
                </h3>

                <p className="mt-2 text-sm text-center text-gray-600">
                    {isBlocked
                        ? `Cannot delete ${driverName} because they are linked to ${deliveryCount} delivery record(s). Please reassign those deliveries first.`
                        : `Are you sure you want to remove ${driverName}? This will permanently delete their driver profile.`}
                </p>

                <div className="mt-6 flex flex-col gap-2">
                    {!isBlocked && (
                        <button
                            onClick={onConfirm}
                            disabled={loading}
                            className="w-full rounded-xl  py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#d01560] bg-[#e6186c] disabled:opacity-50 transition"
                        >
                            {loading ? 'Deleting...' : 'Delete Driver'}
                        </button>
                    )}
                    <button
                        onClick={onClose}
                        className="w-full rounded-xl border border-stone-300 py-2.5 text-sm font-semibold text-white bg-gray-900 hover:bg-gray-800 transition"
                    >
                        {isBlocked ? 'I Understand' : 'Cancel'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteDriverModal;